export const links = {
  home: '/',
  portfolio: '/portfolio',
  confirm: '/Confirm',
  resume: '/resume',
  contact: '/contact',
}
